<script lang="ts">
	import type { Snippet } from "svelte";
	import arrow from "../../../../core/assets/icons/arrow.svg?raw";
	import Icon from "./Icon.svelte";

	const {
		icon = arrow,
		children,
		iconClass = "shrink-0",
		reversed = false,
		transparent = false,
	}: { icon?: string; children: Snippet; iconClass?: string; reversed?: boolean; transparent?: boolean } = $props();
</script>

<div
	class={[
		"flex gap-4",
		reversed ? "flex-row-reverse" : "flex-row",
		transparent ? "justify-start items-start" : "justify-between items-center",
	]}
>
	<span class="shrink-0 sm:uppercase">{@render children()}</span>
	<Icon class={iconClass} {icon} />
</div>
